export const GETENTITY = 'GETENTITY';
export const GETLISTING = 'GETLISTING';
export const SAVEHEROLISTINGS = 'SAVEHEROLISTINGS';
export const SAVEHOMEPAGEFEATUREDLISTINGS = 'SAVEHOMEPAGEFEATUREDLISTINGS';
export const SAVEPRESS = 'SAVEPRESS';
export const LOADCONFIG = 'LOADCONFIG';
export const LOADCURRENCIES = 'LOADCURRENCIES';
export const LOADCURRENCYQUOTES = 'LOADCURRENCYQUOTES';
export const LOADLISTING = 'LOADLISTING';
export const LOADLOCATIONS = 'LOADLOCATIONS';
export const SELECTCURRENCY = 'SELECTCURRENCY';



// WEBPACK FOOTER //
// ./src/constants/action-types.js